import { Component, Input, OnInit } from '@angular/core';
import { FormArray, FormBuilder, FormControl, FormGroup } from '@angular/forms';
import { PopoverController } from '@ionic/angular';

@Component({
    selector: 'app-capture-metadata-popover',
    templateUrl: './capture-metadata-popover.component.html',
    styleUrls: ['./capture-metadata-popover.component.scss'],
    standalone: false
})
export class CaptureMetadataPopoverComponent  implements OnInit {

  @Input() dataPackage: any;
  public metaData = [];
  public wfName: string;
  public formData: FormGroup

  constructor(
    private formBuilder: FormBuilder,
    public popoverController: PopoverController,
  ) { }

  ngOnInit() {
    console.log('CaptureMetadataPopoverComponent initialized');
    this.metaData = this.dataPackage?.metaData || [];
    this.wfName = this.dataPackage?.wfName || 'Capture Workflow';
    console.log('Metadata:', this.metaData);
    this.formData = this.formBuilder.group({
      items: this.formBuilder.array(this.metaData.map(md => this.formBuilder.group({
        name: [md.name],
        label: [md.displayName]
      })))
    });
  }

  get items() {
    return this.formData.get('items') as FormArray;
  }

  onSubmit() {
    console.log('Form submitted:', this.formData.value);
    // if (this.formData.valid) {
    //   console.log('Form submitted:', this.formData.value);
    // }
  }
}
